// extracted by mini-css-extract-plugin
module.exports = {"digital_asset_container":"digitalAssets_digital_asset_container__H_m_4","digital_asset_icon":"digitalAssets_digital_asset_icon__ppc5r"};